<template>
  <b-container
    class="admin-add-view-container"
    v-if="categoriesOptions.length"
  >
    <div
      @click="$refs.fileUpload.click()"
      class="preview"
      v-if="previewURL !== ''"
    >
      <img :src="previewURL" />
    </div>

    <div
      class="preview"
      v-else
      @click="$refs.fileUpload.click()"
    >
      <h3>請選擇要上傳的圖檔</h3>
    </div>
    <input
      @change="onFileSelected"
      style="display: none;"
      type="file"
      name="image"
      ref="fileUpload"
      accept="image/*"
    />

    <b-form @submit.prevent="submitData">
      <b-form-group
        id="input-group-1"
        label="產品中文名稱"
        label-for="input-1"
        description="請填入產品的中文名稱"
      >
        <b-form-input
          id="input-1"
          v-model="formData.name_CH"
          type="text"
          required
          placeholder="輸入產品中文名稱"
          autocomplete="off"
        />
      </b-form-group>

      <b-form-group
        id="input-group-2"
        label="產品英文名稱"
        label-for="input-2"
        description="請填入產品的英文名稱"
      >
        <b-form-input
          id="input-2"
          v-model="formData.name_EN"
          type="text"
          required
          placeholder="輸入產品英文名稱"
          autocomplete="off"
        />
      </b-form-group>

      <b-form-group
        id="input-group-3"
        label="產品尺寸"
        label-for="input-3"
        description="若無定義尺寸則不必填寫"
      >
        <b-form-input
          id="input-3"
          v-model="formData.size"
          type="text"
          placeholder="輸入產品支援尺寸"
          autocomplete="off"
        />
      </b-form-group>

      <b-form-group
        id="input-group-4"
        label="產品分類"
        label-for="input-4"
      >
        <b-form-select
          id="input-4"
          v-model="formData.cateId"
          :options="categoriesOptions"
          required
        />
      </b-form-group>

      <section v-if="!submited">
        <b-button
          type="submit"
          variant="primary"
        >Submit</b-button>
        <b-button
          @click="resetData"
          type="reset"
          variant="danger"
        >Reset</b-button>
      </section>
      <section
        class="sending"
        v-else
      >
        <b-spinner label="Spinning"></b-spinner>
        <p>處理中...</p>
      </section>
    </b-form>
  </b-container>
</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";

  export default {
    mounted() {
      this.mission.ownerId = this.$store.state.login.user.id;

      if (this.$route.query.id) {
        let id = this.$route.query.id;
        this.$store.dispatch("backend/changeFocusProductId", { id });
        this.mission.itemID = id;
        this.mission.type = "edit";
      }
    },
    data() {
      return {
        formData: {},
        mission: {
          system: "Product",
          type: "add",
          date: null,
          ownerId: null,
          supervisor: "",
          state: "pending",
          comment: "",
          product: "",
          itemID: "",
        },
        selectedFile: null,
        previewURL: "",
        submited: false,
      };
    },
    computed: {
      ...mapState("backend", ["missions", "focusProductId"]),
      ...mapGetters("backend", ["filterProductById", "categoriesOptions"]),
    },
    methods: {
      ...mapActions("backend", ["addProduct", "addMission"]),

      onFileSelected: function (event) {
        this.selectedFile = event.target.files[0];
        this.formData.image = this.selectedFile.name;
        this.previewURL = URL.createObjectURL(this.selectedFile);
      },
      resetData: function () {
        this.formData = {
          cateId: this.categoriesOptions[0].value,
        };
        this.selectedFile = null;
        this.previewURL = "";
      },
      submitData: function () {
        this.submited = true;
        this.mission.date = new Date().getTime();
        this.mission.product = this.formData.name_CH;

        this.addMission({
          Statement: this.formData,
          imageSelect: this.selectedFile,
          ...this.mission,
        });
      },
    },
    watch: {
      missions: function () {
        this.$router.push({ name: "admin-home" });
      },
      filterProductById: function () {
        const { id, image, imagePath,...entity } = this.filterProductById;
        this.formData = { ...entity, image, imagePath };
        this.previewURL = imagePath;
      },
      $route: function () {
        if (!this.$route.query.id) {
          this.resetData();
          this.mission.type = "add";
        }
      },
    },
  };
</script>
